import { Box, Skeleton } from "@mui/material";

export const TableLoadingOverlay = ({ columnWidths = [], rowHeight = 45, rowCount = 8, tableWidth = "100%" }) => {
	return (
		<Box
			sx={{
				position: "absolute",
				inset: 0,
				zIndex: 2,
				backgroundColor: "rgba(255,255,255,0.6)",
				backdropFilter: "blur(1px)",
				pointerEvents: "none",
				overflow: "hidden",
			}}>
			<Box sx={{ width: tableWidth, minWidth: "100%" }}>
				{Array.from({ length: rowCount }).map((_, rowIdx) => (
					<Box
						key={rowIdx}
						sx={{
							display: "flex",
							alignItems: "center",
							height: rowHeight,
							px: 1,
						}}>
						{columnWidths.map((width, colIdx) => (
							<Box key={`${rowIdx}-${colIdx}`} sx={{ width, minWidth: width, px: 0.5, height: "100%", boxSizing: "border-box" }}>
								<Skeleton height="90%" />
							</Box>
						))}
					</Box>
				))}
			</Box>
		</Box>
	);
};
